export const mainMenuOptions = [
    {
        id: 1,
        text: "Yük Ekle",
        value: "/yuk-ekle",
        subMenus: []
    },
    {
        id: 2,
        text: "Yükler Listesi",
        value: "/yukler-listesi",
        subMenus: []
    },
    {
        id: 3,
        text: "Yük Ekle",
        value: "/yuk-ekle",
        subMenus: []
    },
    {
        id: 4,
        text: "Atananlar",
        value: "/atananlar",
        subMenus: []
    },
    {
        id: 6,
        text: "Yüklemede",
        value: "/yuklemede",
        subMenus: []
    },
    {
        id: 7,
        text: "Seferde",
        value: "/seferde",
        subMenus: []
    },
    {
        id: 8,
        text: "Boşaltmada",
        value: "/bosaltmada",
        subMenus: []
    },
    {
        id: 9,
        text: "Tamamlanan Seferler",
        value: "/tamamlanan-seferler",
        subMenus: []
    },
    {
        id: 10,
        text: "Yük İşlemleri",
        value: "/yuk-islemleri",
        subMenus: [
            {
                id: 1,
                text: "İş Listesi",
                value: "/is-listesi"
            },
            {
                id: 2,
                text: "Sürücüler ve Araçlarım",
                value: "/devamli-araclarim"
            },
            {
                id: 3,
                text: "Plaka Sorgulama",
                value: "/plaka-sorgulama"
            },
            {
                id: 4,
                text: "Adres Yönetimi",
                value: "/adres-yonetimi"
            },
            {
                id: 5,
                text: "Bölgedeki Tekliflerim",
                value: "/bolgedeki-tekliflerim"
            }
        ]
    },
    {
        id: 11,
        text: "Sürücüler ve Araçlarım - Firmalarım",
        value: "/suruculer-ve-araclarim",
        subMenus: [
            {
                id: 1,
                text: "Sürücüler ve Araçlarım",
                value: "/devamli-araclarim"
            },
            {
                id: 2,
                text: "Firmalarım",
                value: "/firmalarim"
            },
        ]
    },
    {
        id: 12,
        text: "Hesaplamalar",
        value: "/hesaplamalar",
        subMenus: [
            {
                id: 1,
                text: "Sürücüler ve Araçlarım",
                value: "/nakliye-fiyat-hesaplama"
            },
            {
                id: 2,
                text: "Km Hesaplama",
                value: "/km-hesaplama"
            },
            {
                id: 3,
                text: "KDV ve Tevkifat Hesaplama",
                value: "/kdv-ve-tevkifat-hesaplama"
            },
            {
                id: 4,
                text: "Sera Gazı Emisyonu Hesaplama",
                value: "/sera-gazi-emisyonu-hesaplama"
            },
        ]
    },
    {
        id: 13,
        text: "E-Arşiv Fatura",
        value: "/e-arsiv",
        subMenus: [
            {
                id: 1,
                text: "Kestigim Faturalarım",
                value: "/kestigim-faturalarim"
            },
            {
                id: 2,
                text: "Bana Kesilen Faturalar",
                value: "/bana-kesilen-faturalar"
            },
            {
                id: 3,
                text: "e-Arşiv Fatura Kes",
                value: "/fatura-kes"
            },
            {
                id: 4,
                text: "Kayıtlı Müşteriler",
                value: "/kayitli-musteriler"
            },
        ]
    },
    {
        id: 14,
        text: "Uygun Sigorta Bul",
        value: "/uygun-sigorta-bul",
        subMenus: []
    },
    {
        id: 15,
        text: "İlanlar",
        value: "/ilanlar",
        subMenus: [
            {
                id: 1,
                text: "Kiralık Araç Arayan Firmalar",
                value: "/kiralik-arac-arayan-firmalar"
            },
            {
                id: 2,
                text: "Kiralık Araçlar",
                value: "/kiralik-araclar"
            },
            {
                id: 3,
                text: "İş Arayan Sürücüler",
                value: "/is-arayan-surucular"
            },
            {
                id: 4,
                text: "Sürücü Arayanlar",
                value: "/surucu-arayanlar"
            },
            {
                id: 5,
                text: "Satılık Araçlar",
                value: "/satilik-araclar"
            },
        ]
    },
    {
        id: 16,
        text: "Kasa Defteri",
        value: "/kasa-defteri",
        subMenus: []
    },
    {
        id: 17,
        text: "Raporlar",
        value: "/raporlar",
        subMenus: []
    },
    {
        id: 18,
        text: "Profilim",
        value: "/profilim",
        subMenus: [
            {
                id: 1,
                text: "Firma Bilgileri",
                value: "/firma-bilgileri"
            },
            {
                id: 2,
                text: "Firma Belgeleri",
                value: "/firma-belgeleri"
            },
            {
                id: 3,
                text: "Kullanıcılar",
                value: "/kullanicilar"
            },
            {
                id: 4,
                text: "Özvarlık Araçlarım",
                value: "/araclarim"
            },
            {
                id: 5,
                text: "Sürücülerim",
                value: "/suruculerim"
            },
            {
                id: 6,
                text: "Projelerim",
                value: "/projelerim"
            },
        ]
    },
    {
        id: 19,
        text: "U-ETDS Yük Bildirimi",
        value: "/u-etds-yuk-bildirimi",
        subMenus: []
    },
    {
        id: 20,
        text: "Engellenen Sürücüler",
        value: "/engellenen-suruculer",
        subMenus: []
    },
]
